import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Button } from 'ui/button';
import { Tooltip } from 'ui/tooltip';
import { Truncate } from 'ui/utility/truncate';
import { DYNAMIC_CONTENT_INPUT_VARIANTS } from '../../../constants';

const StyledButton = styled(Button)`
  &&& {
    border: none;
    box-shadow: none;
    width: fit-content;

    &[data-error='true'] {
      ${DYNAMIC_CONTENT_INPUT_VARIANTS.ERROR}
    }
    &[data-error='false'] {
      ${DYNAMIC_CONTENT_INPUT_VARIANTS.DEFAULT}
    }
  }
`;

const StyledTruncate = styled(Truncate)`
  && {
    padding: ${({ theme }) => theme.spacing.values.threeEights} 0;
  }
`;

type Props = {
  onClick: () => void;
  isError: boolean;
};

export const ConditionInputButton: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  isError,
  ...props
}) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const ref = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (ref?.current?.offsetWidth && ref?.current?.offsetWidth < ref?.current?.scrollWidth) {
      setIsTruncated(true);
    }
  });
  return (
    <Tooltip isEnabled={isTruncated} tooltipContent={children}>
      <StyledButton {...props} data-error={isError}>
        <StyledTruncate maxWidth={150} ref={ref}>
          {children}
        </StyledTruncate>
      </StyledButton>
    </Tooltip>
  );
};
